/* global femcare */

$(document).ready(function () {
    femcare.mock.api.init();

    femcare.navigation.navigationMain.init();

    femcare.article.pageHeaderHero.init();
    femcare.shared.heroSlider.init();

    femcare.video.init();
    femcare.video.youtubeVideo.init();
    femcare.video.tiktokVideo.init();

    femcare.article.infographic.init();
    femcare.askExpert.askQuestion.init();
    femcare.askExpert.questions.init();

    femcare.product.productList.init();
    femcare.product.productFilter.init();
    femcare.product.productFilterCategory.init();
    femcare.product.productSort.init();

    femcare.newsletter.popupNewsletter.init();
    femcare.share.socialShare.init();

    femcare.search.searchBar.init();
    femcare.search.searchModal.init();

    femcare.sampleCoupon.order.init();

    femcare.shared.accordionDefault.init();
    femcare.shared.verticalTabs.init();

    femcare.tracking.analyticsEvents.init();
    femcare.tracking.gaTracking.init();
    femcare.tracking.forms.init();

    femcare.shared.inputs.init();

    femcare.ageVerification.verification.init();

    femcare.general.anchorLink.init();

    femcare.form.recaptcha.init();
    femcare.form.validationInitialization.init();
    femcare.form.phoneInput.init();
    femcare.form.protection.init();
    femcare.form.fileUpload.init();

    femcare.quiz.base.init();
    femcare.quiz.standard.init();
    femcare.quiz.shareable.init();
    femcare.quiz.nps.init();

    femcare.shared.animation.init();

    femcare.audioPlatform.init();

    femcare.breadcrumbs.init();
    femcare.modal.init();
    femcare.popup.init();
    femcare.ctaPanel.quickBuy.init();

    femcare.accessibility.init();

    femcare.shared.util.toggleStoreButtonsByDevice();

    femcare.storeLocator.init();

    femcare.tooltip.init();
    femcare.ichLabelCollector.init();

    femcare.periodTracker.calculator.init({ skipRendering: true }); // Period Calculator v3
    femcare.form.circularDatePicker.init();
});

/**
 * Init slides on window.load (after images are loaded).
 * */
$(window).on('load', function () {
    // Panel info related code needs to be initialized after protection token is ready in cart.init()
    femcare.product.cart.init().then(function() {
        femcare.product.panel.info.default.init();
        femcare.product.panel.info.shop.init();
        femcare.product.panel.info.slider.init();
        femcare.ctaPanel.colorSelector.init();
    });

    femcare.navigation.cookieNotice.init();
    femcare.product.accordion.init();
    femcare.product.viewer360.init();
    femcare.gallery.retailers.init();
    femcare.shared.slider.init();
    femcare.tracking.product.init();

    femcare.product.measurement.init();
    femcare.gallery.article.init();
    femcare.gallery.image.init();
    femcare.gallery.innovation.init();
    femcare.shared.rangeSlider.init();

    femcare.navigation.anchor.init();

    femcare.product.safetySection.init();
    femcare.form.periodTracker.init(); // Deprecated period tracker

    femcare.product.standaloneReview.init();

    femcare.banner.init();
});
